const syncBonusSummary = (data, total) => {
    if (typeof total !== 'number' || !Number.isFinite(total)) return data;

    const amount = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(total);
    const syncText = (text) => typeof text === 'string' ? text.replace(
        /(\b(?:worth|(?:combined|total)(?:\s+bonus)?\s+value)\s*:?\s*(?:₹\s*|INR\s*|Rs\.?\s*))\d[\d,]*(?:\.\d+)?/gi,
        (_, prefix) => `${prefix}${amount}`
    ) : text;

    return { ...data, title: syncText(data.title), subtitle: syncText(data.subtitle) };
};

export default syncBonusSummary;
